import { createRequiredContext } from '../createRequiredContext';
const { useContext, Provider, Context, Consumer } = createRequiredContext('Sentry');
export const SentryProvider = Provider;
export const SentryConsumer = Consumer;
export const SentryContext = Context;
export const useSentry = useContext;
//# sourceMappingURL=SentryProvider.js.map